import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["defaultChecked", "required", "name", "value", "id", "checked", "onCheckedChange", "disabled", "style", "className", "as", "css", "labelPosition", "label"];
import { Check, X } from "lucide-react";
import React from "react";
import Stack from "../Stack";
import LABEL_DIRECTIONS from "./constants/labelDirections";
import { BaseSwitch, BaseSwitchLabel, BaseSwitchThumb } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var iconProps = {
  color: "currentColor",
  size: "0.875rem"
};
var Switch = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var defaultChecked = _ref.defaultChecked,
    required = _ref.required,
    name = _ref.name,
    value = _ref.value,
    id = _ref.id,
    checked = _ref.checked,
    onCheckedChange = _ref.onCheckedChange,
    disabled = _ref.disabled,
    style = _ref.style,
    className = _ref.className,
    as = _ref.as,
    css = _ref.css,
    _ref$labelPosition = _ref.labelPosition,
    labelPosition = _ref$labelPosition === void 0 ? "left" : _ref$labelPosition,
    label = _ref.label,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var direction = LABEL_DIRECTIONS[labelPosition];
  return /*#__PURE__*/_jsxs(Stack, {
    direction: direction,
    align: "center",
    children: [label && /*#__PURE__*/_jsx(BaseSwitchLabel, {
      direction: labelPosition,
      disabled: disabled,
      htmlFor: id,
      children: label
    }), /*#__PURE__*/_jsxs(BaseSwitch, _extends({
      defaultChecked: defaultChecked,
      required: required,
      name: name,
      value: value,
      disabled: disabled,
      id: id,
      checked: checked,
      onCheckedChange: onCheckedChange,
      ref: forwardedRef
    }, restProps, {
      children: [/*#__PURE__*/_jsx(BaseSwitchThumb, {
        checked: checked
      }), checked ? /*#__PURE__*/_jsx(Check, _extends({}, iconProps)) : /*#__PURE__*/_jsx(X, _extends({}, iconProps))]
    }))]
  });
});
Switch.displayName = "Switch";
export default Switch;